import _get from 'lodash/get';
import axios from 'axios'; // eslint-disable-line import/no-extraneous-dependencies
import * as types from '../constants/ActionTypes';

const TOPIC_TREE_URL = '/smarthelp/topic-tree';
const TOPIC_MESSAGE = 'topictree request canceled';

const CancelToken = axios.CancelToken;
const source = CancelToken.source();


function requestTopicTreeData() {
  return {
    type: types.REQUEST_TOPIC_TREE,
    payload: undefined,
  };
}

function receiveTopicTreeData(topicTree) {
  return {
    type: types.RECEIVE_TOPIC_TREE_RESPONSE,
    payload: topicTree,
  };
}


function receiveTopicTreeDataError() {
  return (dispatch, getState) => {
    const isContactDisplayed = getState().contactChannels.display;
    return dispatch({
      type: types.RECEIVE_TOPIC_TREE_ERROR,
      payload: isContactDisplayed,
    });
  };
}

function fetchTopicTree() {
  return (dispatch) => {
    dispatch(requestTopicTreeData());
    return axios.get(TOPIC_TREE_URL, {
      cancelToken: source.token,
    })
      .then((response) => {
        const topicTree = _get(response.data, 'topicTree.contact_email_template', {});
        const subtopics = topicTree && topicTree.sub_topics;
        if (Array.isArray(subtopics) && subtopics.length > 0) {
          dispatch(receiveTopicTreeData(topicTree));
        } else {
          dispatch(receiveTopicTreeDataError());
        }
      })
      .catch((error) => {
        if (error && error.message !== TOPIC_MESSAGE) {
          dispatch(receiveTopicTreeDataError());
        }
      });
  };
}
function cancelTopicTreeRequest() {
  source.cancel(TOPIC_MESSAGE);
}


module.exports = {
  fetchTopicTree,
  cancelTopicTreeRequest,
};
